import { Injectable } from '@angular/core';

@Injectable()
export class WindowService {
  private _window = window;

  get nativeWindow() {
    return this._window;
  }

  get location() {
    return this._window.location;
  }

  get navigator() {
    return this._window.navigator;
  }

  /**
   * Changes the href of the location.
   *
   * @param {string} href new href
   * */
  changeLocation(href: string) {
    this._window.location.href = href;
  }

  /**
   * Opens the given URL in a new tab.
   *
   * @param url the URL to be opened
   */
  open(url: string) {
    this._window.open(url);
  }
}
